import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { UserDetailsContext } from "../../context/userDetails";
import { GETTING_STARTED, HOME, LanguageKeys, SETUP_FLOW, STEPS, STREAM_SCAN } from "../../vars";
import { LanguageContext } from "../../context/languageContext";
import SpecificButton from "../specificButton/SpecificButton";

function CameraPermissionModal({ browserName, message }) {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);
  const { setSteps } = useContext(UserDetailsContext);
  const { pathname } = useLocation();
  const { translate } = useContext(LanguageContext);
  const handleClose = () => {
    setOpen(false);
    if (pathname.includes(STREAM_SCAN)) {
      navigate(SETUP_FLOW);
    } else if (pathname.includes(GETTING_STARTED)) {
      setSteps(STEPS.CAMERA_PERMISSION);
      navigate(HOME);
    }
  };
  return (
    <Dialog open={open} onClose={handleClose} className="confirm-modal">
      <div className="modal-main">
        <div className="text-center">
          {message ? (
            <>
            <h2 className="text-[26px]">Seems camera already in use</h2>
              <p className="mt-2 text-sm">Can you try closing the browser/app that is using the camera and try again here. </p>
            </>
          ) : (
            <>
              <h2 className="text-[26px]">{translate(LanguageKeys.Please_check_your_setting_for_camera_permission)}</h2>
              <p className="mt-2 text-sm">{`${translate(LanguageKeys.Settings)} > ${browserName} > ${translate(LanguageKeys.Enable_the_camera_permissions)}`}</p>
              <div className="my-4"> 
              <SpecificButton buttonText=  {translate(LanguageKeys.Go_Back)} className="button-primary" buttonFunc={handleClose} />
              </div>
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
}

export default CameraPermissionModal;
